export var some = function some(arr, pred) {
  arr = arr || [];

  for (var i = 0; i < arr.length; ++i) {
    if (pred && pred(arr[i])) {
      return true;
    }
  }

  return false;
};
export var toPairs = function toPairs(obj) {
  return obj ? Object.keys(obj).map(function (k) {
    return [k, obj[k]];
  }) : [];
};
export var fromPairs = function fromPairs(arr) {
  var ret = {};
  (arr || []).forEach(function (_ref) {
    var k = _ref[0],
        v = _ref[1];
    return ret[k] = v;
  });
  return ret;
};
export var mapValues = function mapValues(obj, mapper, filter) {
  if (mapper === void 0) {
    mapper = function mapper(v) {
      return v;
    };
  }

  if (filter === void 0) {
    filter = function filter() {
      return true;
    };
  }

  return fromPairs(toPairs(obj).filter(function (_ref2) {
    var k = _ref2[0],
        v = _ref2[1];
    return filter(v, k);
  }).map(function (_ref3) {
    var k = _ref3[0],
        v = _ref3[1];
    return [k, mapper(v, k)];
  }));
};
export var isFunction = function isFunction(func) {
  return typeof func === 'function';
};